import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { HelmetProvider } from 'react-helmet-async'
import { store } from './store'
import AppRouter from './router'
import { useTheme } from './hooks/useTheme'
import './styles/global.css'

const ThemeWrapper = () => {
  useTheme()
  return <AppRouter />
}

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <ThemeWrapper />
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
)

const rootElement = document.getElementById('root')

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app)
} else {
  ReactDOM.createRoot(rootElement).render(app)
}